// import { FetchBaseQueryArgs } from '@reduxjs/toolkit/dist/query/fetchBaseQuery'
import {
  // BaseQueryFn,
  // FetchArgs,
  fetchBaseQuery,
  // FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { setCurrentUser } from "../redux/slices/authSlice";
import CryptoJS from "crypto-js";

export const baseQueryWithAuthInterceptor = (args) => {
  args = {
    ...args,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('authToken')
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }
  const baseQuery = fetchBaseQuery(args);
  return async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);
    if (
      result.error &&
      (result.error.status === 401 || result.error.originalStatus === 401)
    ) {
      api.dispatch(setCurrentUser(null));
    }
    result.data = result.data && decryptResponse(result.data);
    // console.log('result.data: ', result.data);
    return result;
  };
};
// (args: FetchBaseQueryArgs) => BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> =

export const AuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  if (token) return { Authorization: `Bearer ${token}` }
}

const SECRET_KEY = process.env.REACT_APP_AES_SECRET_KEY;

export function decryptResponse(encryptedRes) {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedRes.encryptedData, SECRET_KEY);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

    try {
      return JSON.parse(decryptedText);
    } catch {
      return decryptedText;
    }
  } catch (err) {
    return encryptedRes;
  }
}